import { clientPost } from "@/service/client-api/client-api";
import { logEvent } from "@/service/logs/log";

export function createInternshipReportComment(id, logView, router) {
  return async (content: string) => {
    if (content.length === 0) {
      return;
    }

    try {
      await clientPost(
        "comment.create",
        {
          resourceType: "internship_report",
          resourceId: id,
        },
        {
          content,
        },
      );
    } catch ({ error }) {
      alert(error);
    }

    logEvent("internship_report_add_comment", logView, {
      report_id: id,
      comment_content: content,
    });
    router.refresh();
  };
}
